document.addEventListener('DOMContentLoaded', function () {
  const swiperAdvan = new Swiper('.advantages__wrapper-mob .card-list', {
    spaceBetween: 20,
    pagination: {
      el: '.advantages-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    }
  });
  
  const swiperReviews = new Swiper('.team__wrapper__swiper', {
    spaceBetween: 20,
    pagination: {
      el: '.team-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.team-swiper-button-next',
      prevEl: '.team-swiper-button-prev',
    },
    slidesPerView: 3,
    slidesPerGroup: 1,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 1,
      },
      320: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    }
  });
  
  const swiperSchedule = new Swiper('.schedule__wrapper__swiper', {
    spaceBetween: 20,
    pagination: {
      el: '.schedule-swiper-pagination',
      clickable: true,
      type: 'fraction',
    },
    navigation: {
      nextEl: '.schedule-swiper-button-next',
      prevEl: '.schedule-swiper-button-prev',
    },
    slidesPerView: 1,
    slidesPerGroup: 1
  });
  
  const swiperResults = new Swiper('.results__wrapper__swiper', {
    spaceBetween: 20,
    pagination: {
      el: '.results-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.results-swiper-button-next',
      prevEl: '.results-swiper-button-prev',
    },
    slidesPerView: 1,
    slidesPerGroup: 1
  });
  
  window.addEventListener("DOMContentLoaded", function () {
    [].forEach.call(document.querySelectorAll('.phone-mask'), function (input) {
      var keyCode;
      function mask(event) {
        event.keyCode && (keyCode = event.keyCode);
        var pos = this.selectionStart;
        if (pos < 3) event.preventDefault();
        var matrix = "+7 (___)-___-__-__",
          i = 0,
          def = matrix.replace(/\D/g, ""),
          val = this.value.replace(/\D/g, ""),
          new_value = matrix.replace(/[_\d]/g, function (a) {
            return i < val.length ? val.charAt(i++) || def.charAt(i) : a
          });
        i = new_value.indexOf("_");
        if (i != -1) {
          i < 5 && (i = 3);
          new_value = new_value.slice(0, i)
        }
        var reg = matrix.substr(0, this.value.length).replace(/_+/g,
          function (a) {
            return "\\d{1," + a.length + "}"
          }).replace(/[+()]/g, "\\$&");
        reg = new RegExp("^" + reg + "$");
        if (!reg.test(this.value) || this.value.length < 5 || keyCode > 47 && keyCode < 58) this.value = new_value;
        if (event.type == "blur" && this.value.length < 5) this.value = ""
      }
  
      input.addEventListener("input", mask, false);
      input.addEventListener("focus", mask, false);
      input.addEventListener("blur", mask, false);
      input.addEventListener("keydown", mask, false)
    });
  });
  
  let showMoreBtnText = document.querySelector('.text-block__wrapper__text .show-more');
  let textBlock = document.querySelector('.text-block__wrapper__text p');

  /*if (showMoreBtnText && typeof showMoreBtnText != "undefined") {
    showMoreBtnText.addEventListener('click', function () {
      this.classList.toggle('active');
    
      if (this.classList.contains('active')) {
        this.innerHTML = 'Скрыть';
        textBlock.classList.add('show');
      } else {
        this.innerHTML = 'Показать больше';
        textBlock.classList.remove('show');
      }
    }); 
  }*/
});
